import { i18n, interfaceLocale } from "./index";

// These are stored system values. Translate only their labels, never record values or user text.
const teachingTypes = {
  功課: "homework",
  測驗: "assessment",
  默書: "dictation",
  溫習: "revision",
  帶備物品: "materials",
  回條: "replySlip",
} as const;

export function teachingItemLabel(value: string) {
  const key = teachingTypes[value as keyof typeof teachingTypes];
  return key ? i18n.t(`interfaceExtras:${key}`) : value;
}

const taskTypes = {
  exercise: "exercise",
  worksheet: "worksheet",
  notes: "notes",
  classwork: "classwork",
  revision: "revisionDictation",
  replySlip: "replySlip",
  other: "other",
} as const;

export function homeroomHomeworkTaskLabel(value?: string) {
  const key = taskTypes[value as keyof typeof taskTypes] || "exercise";
  return i18n.t(`interfaceExtras:${key}`);
}

export function weekdayLabels() {
  const format = new Intl.DateTimeFormat(interfaceLocale(), { weekday: "short", timeZone: "UTC" });
  return Array.from({ length: 7 }, (_, day) => format.format(new Date(Date.UTC(2023, 0, 1 + day))));
}
